module.exports = __webpack_public_path__ + "img/download.a22f2633.svg";